import { IEnvironmentModel } from './environment.model';

export const productionEnvironment: IEnvironmentModel = {
  type: 'production',
  production: true,
  dev: false,
  domain: 'di.hrm.visma.net',

  // logging
  enableBrowserLogs: true,
  enableRUM: true,

  // authentication and client IDs
  dummyAuth: false,
  signinUrl: 'https://signin.visma.net/loginwebapp',
  loginRedirectUrl: 'https://di.hrm.visma.net',
  oauth: {
    issuer: 'https://connect.visma.com',
    clientId: 'VismaNetHrmDataImport',
  },
  ldClientSideID: '608646fe68cb1c0b9fe4761e',
  wootricAccountToken: 'NPS-EU-2afb00ff',
  survicateWorkspaceKey: 'eb46d80c519e2924108929436aaf8ed5',

  // APIs
  dataImportApiBaseUrl: 'https://api.di.hrm.visma.net',
  staticJsonApiBaseUrl: 'https://static-json.no.visma.net/',
  wsBaseUrl: 'wss://ws.di.hrm.visma.net',

  // external links
  empManModuleId: 16208,
  vismaHomeUrl: 'https://home.visma.com/',
  vismaEmpmanUrl: 'https://web.employeecore1.hrm.visma.net/uiempmanapp/',
  vismaAboutUrl: 'https://wagerun.cj.hrm.visma.net/',
  vismaCalendarUrl: 'https://web.calendar.hrm.visma.net/',
  payrollUiUrl: 'https://payrollui.no.visma.net/',
  payrollPortal:
    'https://web.calendar.hrm.visma.net/absence/_Svelte/dist/scripts/es/ClientPortalComponentProvider.js',
  wagerunUrl: 'https://wagerun.cj.hrm.visma.net',
  accountSettingsUrl: 'https://accountsettings.connect.visma.com/',

  // embedded components
  timeDocumentsUrl: 'https://ui.time.hrm.visma.net/timeui/dist/clientportal-component-provider.js',
  variableTransactionsUrl:
    'https://wagerun.cj.hrm.visma.net/componentProviders/employeeTransactionsProviderV1.js',
  employeeRecurringUrl:
    'https://wagerun.cj.hrm.visma.net/componentProviders/employeeRecurringProvider.js',
  assistant: {
    apiBaseUrl: 'https://api.assistant.vsn.dev',
    profileId: 'payroll-prod',
  },
  walkmeSrc:
    'https://eu-cdn.walkme.com/users/156f0c8fa19a4b7cbd7437d888ce43cc/walkme_private_156f0c8fa19a4b7cbd7437d888ce43cc_https.js',
  walkmeIntegrity: 'sha256-bLZ0I5NX1aRtz99HlrpFoeWVRLOlAerodXrCyWe5RvA=',
};
